// extracted by mini-css-extract-plugin
module.exports = {"uploadAvatar":"_2WS74","avatarIcon":"_1nH35","cursorActive":"_3PQ1b","loading":"BhEyC","spinner":"_16ju5"};